import React from "react";
import "./SignUp.scss";
import FirstFormStep from "./FirstFormStep";
import SecondFormStep from "./SecondFormStep";
import MainBonusBox from "./MainBonusBox";

function MSignUp() {
  const [currentStep, setCurrentStep] = React.useState(1);

  return (
    <div className='app-full-content'>
      <div className='signup-page-content'>
        <div className='signup-header-title'>
          <h4>Sign Up</h4>
        </div>
        <div className='banner-box'>
          <img src='/baner-signup.png' alt='Logo' className='banner-img' />
          <div className='banner-gradient' />
          <MainBonusBox />
        </div>
        <div className='box-frame-signup'>
          {currentStep === 1 ? (
            <FirstFormStep
              onClickButton={() => {
                setCurrentStep(2);
              }}
            />
          ) : (
            <SecondFormStep />
          )}
        </div>
      </div>
    </div>
  );
}

export default MSignUp;
